import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolEmptyState } from '../../../models/core/sol-empty-state';
import { SolButtonComponent } from '../sol-button/sol-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolText } from '../../../models/core/sol-text';
import { SolIcon } from '@sol/icons';
import { SolIconComponent } from '../sol-icon/sol-icon.component';
import { SolButton } from '../../../models/core/sol-button';
import { SolTextBoxComponent } from '../sol-text-box/sol-text-box.component';

@Component({
  selector: 'sol-empty-state',
  imports: [SolButtonComponent, SolIconComponent, TranslatePipe, SolTextBoxComponent],
  templateUrl: './sol-empty-state.component.html',
  host: { role: 'status', '[attr.title]': 'null' },
})
export class SolEmptyStateComponent extends AbstractComponent<SolEmptyState> {
  // Computed
  protected readonly id$ = this.compute(state => state.id);
  protected readonly title$ = this.compute(state => state.title);
  protected readonly hasText$ = this.compute(state => state.hasText);
  protected readonly text$ = this.compute(state => state.text);
  protected readonly icon$ = this.compute(state => state.icon);
  protected readonly hasIcon$ = this.compute(state => state.hasIcon);
  protected readonly actionButton$ = this.compute(state => state.actionButton);
  protected readonly hasCustomContent$ = this.compute(state => state.hasCustomContent);

  // Events
  @Output('action')
  public actionEmitter = new EventEmitter<void>();

  constructor() {
    super(SolEmptyState.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return 'sol-empty-state-container';
  }

  @Input()
  public set emptyState(emptyState: SolEmptyState) {
    this.patch(emptyState);
  }

  @Input()
  public set title(title: SolText) {
    this.update(state => state.withTitle(title));
  }

  @Input()
  public set text(text: SolText | undefined) {
    this.update(state => state.withText(text));
  }

  @Input()
  public set actionButton(actionButton: SolButton | undefined) {
    this.update(state => state.withActionButton(actionButton));
  }

  @Input()
  public set icon(icon: SolIcon | undefined) {
    this.update(state => state.withIcon(icon));
  }

  @Input()
  public set customContent(customContent: boolean) {
    this.update(state => state.withCustomContent(customContent));
  }

  protected onAction(): void {
    if (this.state.hasAction) {
      this.actionEmitter.emit();
    }
  }
}
